"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentstackEmailForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _style = require("./style");

var _Email = _interopRequireDefault(require("./components/Email"));

var _Birthday = _interopRequireDefault(require("./components/Birthday"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ContentstackEmailForm = function ContentstackEmailForm(_ref) {
  var globalConfig = _ref.globalConfig,
      pageConfig = _ref.pageConfig,
      lang = _ref.lang;
  var form = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, pageConfig), globalConfig);
  }, [pageConfig, globalConfig]);

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      birthdate = _useState2[0],
      setBirthday = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSignedUp = _useState6[0],
      setIsSignedUp = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      hasError = _useState8[0],
      setHasError = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      successURL = _useState10[0],
      setSuccessURL = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      errorURL = _useState12[0],
      setErrorURL = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      puuid = _useState14[0],
      setPuuid = _useState14[1];

  var emailSignupStatusKey = "email-signup-status-".concat(form.salesforce_external_key);

  var formatLang = function formatLang(lang) {
    // Salesforce CRM requires locales to be in the RiotLocale format - e.g. "en_US" instead of "en-us"
    return lang.replace("-", "_").replace(/\_(.*)$/g, function (char) {
      return char.toUpperCase();
    });
  };

  var parseNonUSDate = function parseNonUSDate(date) {
    var tokens = date.split("/");
    return "".concat(tokens[1], "/").concat(tokens[0], "/").concat(tokens[2]);
  };

  var formatDate = function formatDate(date) {
    var convertedDate = lang === "en-us" ? date : parseNonUSDate(date);
    return convertedDate.toString();
  };

  var checkSignupStatus = (0, _react.useCallback)(function () {
    // Salesforce DEManager sends error messages via query params only. There is no JSON response.
    // Sadly, Salesforce DEManager won't send you a more detailed error message about why exactly it failed.
    // Most common reason for failure I've found from testing: missin external key or successURL/errorURL.
    // Measures to minimize errors:
    // 1) The external key is a required field in the CMS entry.
    // 2) successURL and errorURL are optional fields in the CMS entry but I set successURL and errorURL to default to the current page.
    // 3) Client-side input validation for email and birthdate
    if (window.localStorage.getItem(emailSignupStatusKey) && window.localStorage.getItem(emailSignupStatusKey) === "submitted" && // we set localStorage key when the form is submitted
    !window.location.search.includes("errMsg=An+error+occurred+updating+the+data+extension" // Salesforce won't set this query param if the submission was successfully saved
    )) {
      return true;
    }

    window.localStorage.removeItem(emailSignupStatusKey); // TODO: Show user a message if signup failed? We currently only have a "success" message.

    return false;
  }, [emailSignupStatusKey]);

  var handleClick = function handleClick() {
    window.localStorage.setItem(emailSignupStatusKey, "submitted");
  };

  (0, _react.useEffect)(function () {
    setSuccessURL(form.successURL ? window.location.origin + form.successURL : window.location.href);
    setErrorURL(form.errorURL ? window.location.origin + form.errorURL : window.location.href);

    if ( // @ts-ignore
    _typeof(window.RiotBar) !== "undefined" && // @ts-ignore
    window.RiotBar.account.getAuthState().sub !== "") {
      // @ts-ignore
      setPuuid(window.RiotBar.account.getAuthState().sub); // if no puuid is available, Salesforce defaults to using email as the puuid
    }

    setIsSignedUp(checkSignupStatus());
  }, [form, successURL, errorURL, puuid, isSignedUp, checkSignupStatus]);
  return /*#__PURE__*/_react.default.createElement(_style.StyledForm, null, isSignedUp ? /*#__PURE__*/_react.default.createElement("div", {
    className: "post-signup"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "post-signup-content"
  }, /*#__PURE__*/_react.default.createElement("h1", null, form.post_signup_header), form.post_signup_message && /*#__PURE__*/_react.default.createElement("p", null, form.post_signup_message))) : /*#__PURE__*/_react.default.createElement("form", {
    name: "subscribeForm",
    className: "signup",
    action: "https://cl.s10.exct.net/DEManager.aspx",
    method: "post",
    encType: "application/x-www-form-urlencoded"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_clientID",
    value: "100025126"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_deExternalKey",
    value: form.salesforce_external_key || ""
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_action",
    value: "add/update"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_returnXML",
    value: "1"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_successURL",
    value: successURL
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "_errorURL",
    value: errorURL
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "puuid",
    value: puuid || email
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: form.email_list_name.toLowerCase(),
    value: "true"
  }), form.age_gating_enabled && /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "birth date",
    value: formatDate(birthdate)
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "opt_in",
    value: "true"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "language preference",
    value: formatLang(lang)
  }), /*#__PURE__*/_react.default.createElement("h1", null, form.title), form.subhead && /*#__PURE__*/_react.default.createElement("p", {
    className: "subheader-dark"
  }, form.subhead), /*#__PURE__*/_react.default.createElement(_style.StyledField, null, /*#__PURE__*/_react.default.createElement(_Email.default, {
    errorMessage: form.error_messages.invalid_email,
    label: form.email_field_label,
    onChange: function onChange(email) {
      return setEmail(email);
    },
    onError: function onError(error) {
      return setHasError(error);
    }
  })), form.age_gating_enabled && /*#__PURE__*/_react.default.createElement(_style.StyledField, null, /*#__PURE__*/_react.default.createElement(_Birthday.default, {
    errorMessage: form.error_messages.invalid_dob,
    label: form.date_of_birth_field_label,
    format: form.date_of_birth_format,
    lang: lang,
    onChange: function onChange(birthday) {
      return setBirthday(birthday);
    },
    onError: function onError(error) {
      return setHasError(error);
    }
  })), /*#__PURE__*/_react.default.createElement(_style.StyledButton, {
    disabled: hasError || form.age_gating_enabled && birthdate === "" || email === "",
    type: "submit",
    onClick: handleClick
  }, form.email_cta)));
};

exports.ContentstackEmailForm = ContentstackEmailForm;